import React from 'react';

// Modal types: wide, widest

export default class extends React.Component {
    static propTypes = {
        type: React.PropTypes.string.isRequired,
        title: React.PropTypes.any.isRequired,
        children: React.PropTypes.any.isRequired,
        closeCallback: React.PropTypes.func.isRequired
    };

    render() {

        const containerCSSClass = 'modal-container ' + this.props.type;

        return (
            <div className="single-content-modal">
                <div className={containerCSSClass}>
                    <div className="modal-header">
                        {this.props.title}
                        <div className="close" onClick={this.props.closeCallback}></div>
                    </div>
                    <div className="modal-content">{this.props.children}</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/shared/components/SingleContentModal.jsx